import * as Types from '../../generated.types'

import { OnboardingWorkflowFragmentDoc } from '../../fragments/OrganizationFragment_gen'
import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { fetchGql } from '@alice-financial/api'
export type AdminOrganizationsQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']>
  after?: Types.InputMaybe<Types.Scalars['String']>
  last?: Types.InputMaybe<Types.Scalars['Int']>
  before?: Types.InputMaybe<Types.Scalars['String']>
}>

export type AdminOrganizationsQuery = {
  __typename?: 'Query'
  adminOrganizations: {
    __typename?: 'OrganizationConnection'
    totalCount: number
    totalCountMtd: number
    launchedCount: number
    launchedCountMtd: number
    launchedEmployeeCount: number
    launchedEmployeeCountMtd: number
    pageInfo: {
      __typename?: 'PageInfo'
      hasNextPage: boolean
      hasPreviousPage: boolean
      startCursor?: string | null
      endCursor?: string | null
    }
    nodes?: Array<{
      __typename?: 'Organization'
      id: number
      name?: string | null
      legalName?: string | null
      contractSignedOn?: string | null
      launchDate?: string | null
      isOnboarded?: boolean | null
      logo?: { __typename?: 'Image'; url?: string | null; thumbnailUrl?: string | null } | null
      employers: Array<{ __typename?: 'Employer'; id: number } | null>
      workLocations: Array<{ __typename?: 'WorkLocation'; id: number } | null>
      employees: { __typename?: 'EmployeeConnection'; enrolledCount: number; reachableCount: number }
      onboardingWorkflow?: {
        __typename?: 'OnboardingWorkflow'
        id: number
        status: Types.OnboardingStatus
        activityLog: Array<{
          __typename?: 'OnboardingLogMessage'
          what: string
          when: string
          stepType: Types.OnboardingStepType
          resourceUrl?: string | null
          who?: { __typename?: 'OnboardingLogUser'; id: number; name: string; email: string } | null
        }>
        steps: Array<{
          __typename?: 'OnboardingStep'
          id: number
          stepType: Types.OnboardingStepType
          status: Types.OnboardingStatus
          assignee: {
            __typename?: 'User'
            id: number
            firstName?: string | null
            lastName?: string | null
            email?: string | null
          }
          tasks: Array<{
            __typename?: 'OnboardingStepTask'
            id: number
            taskType: string
            status: Types.OnboardingStatus
          }>
        }>
      } | null
    } | null> | null
  }
}

export type OrganizationOverviewFragment = {
  __typename?: 'Organization'
  id: number
  name?: string | null
  legalName?: string | null
  contractSignedOn?: string | null
  launchDate?: string | null
  isOnboarded?: boolean | null
  logo?: { __typename?: 'Image'; url?: string | null; thumbnailUrl?: string | null } | null
  employers: Array<{ __typename?: 'Employer'; id: number } | null>
  workLocations: Array<{ __typename?: 'WorkLocation'; id: number } | null>
  employees: { __typename?: 'EmployeeConnection'; enrolledCount: number; reachableCount: number }
  onboardingWorkflow?: {
    __typename?: 'OnboardingWorkflow'
    id: number
    status: Types.OnboardingStatus
    activityLog: Array<{
      __typename?: 'OnboardingLogMessage'
      what: string
      when: string
      stepType: Types.OnboardingStepType
      resourceUrl?: string | null
      who?: { __typename?: 'OnboardingLogUser'; id: number; name: string; email: string } | null
    }>
    steps: Array<{
      __typename?: 'OnboardingStep'
      id: number
      stepType: Types.OnboardingStepType
      status: Types.OnboardingStatus
      assignee: {
        __typename?: 'User'
        id: number
        firstName?: string | null
        lastName?: string | null
        email?: string | null
      }
      tasks: Array<{
        __typename?: 'OnboardingStepTask'
        id: number
        taskType: string
        status: Types.OnboardingStatus
      }>
    }>
  } | null
}

export const OrganizationOverviewFragmentDoc = `
    fragment OrganizationOverview on Organization {
  id
  name
  legalName
  contractSignedOn
  launchDate
  isOnboarded
  logo {
    url
    thumbnailUrl
  }
  employers {
    id
  }
  workLocations {
    id
  }
  employees {
    enrolledCount
    reachableCount
  }
  onboardingWorkflow {
    ...OnboardingWorkflow
  }
}
    `
export const AdminOrganizationsDocument = `
    query AdminOrganizations($first: Int, $after: String, $last: Int, $before: String) {
  adminOrganizations(first: $first, after: $after, last: $last, before: $before) {
    totalCount
    totalCountMtd
    launchedCount
    launchedCountMtd
    launchedEmployeeCount
    launchedEmployeeCountMtd
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    nodes {
      ...OrganizationOverview
    }
  }
}
    ${OrganizationOverviewFragmentDoc}
${OnboardingWorkflowFragmentDoc}`
export const useAdminOrganizationsQuery = <TData = AdminOrganizationsQuery, TError = Error>(
  variables?: AdminOrganizationsQueryVariables,
  options?: UseQueryOptions<AdminOrganizationsQuery, TError, TData>
) =>
  useQuery<AdminOrganizationsQuery, TError, TData>(
    variables === undefined ? ['AdminOrganizations'] : ['AdminOrganizations', variables],
    fetchGql<AdminOrganizationsQuery, AdminOrganizationsQueryVariables>(
      AdminOrganizationsDocument,
      variables
    ),
    options
  )

useAdminOrganizationsQuery.getKey = (variables?: AdminOrganizationsQueryVariables) =>
  variables === undefined ? ['AdminOrganizations'] : ['AdminOrganizations', variables]
